import { CircularProgress } from "@mui/material";
import { useNavigation } from "react-router-dom";

import AppWrapper from "../../../components/cm/AppWrapper";
import Reports from "../../../components/cm/Dashboard/FullPages/Reports";
import SideBarMain from "../../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../../components/cm/SideBarMain/MainNavBarEnum";

export default () => {
  const { state } = useNavigation();

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.REPORTS} />}>
      {/* This handles the load when you're leaving the page */}
      {state === "loading" ? (
        <div className="flex items-center justify-center w-full h-full">
          <CircularProgress color="primary" />
        </div>
      ) : (
        <Reports />
      )}
    </AppWrapper.WithSidebar>
  );
};
